<template>
<div class="clm-footer-wrap">
  <footer class="clm-footer">
    <div class="clm-footer__container clm-container">
      <div class="clm-footer__block">
        <div class="clm-footer__copyright" v-html="copyright"></div>
        <div class="clm-footer__policy-info">
          <template v-for="link in links">
            <a v-if="link.link" :href="`${link.link}`" target="_blank">{{ link.text }}</a>
            <span v-else v-html="link.text"></span>
          </template>
        </div>
        <div class="clm-footer__author" v-html="developer"></div>
      </div>
    </div>
  </footer>
</div>
</template>

<script>
export default {
  name: "the-auth-footer",
  props: {
    copyright: String,
    developer: String,
    links: {
      type: Array,
      default: []
    }
  }
}
</script>